import ApeironComponent from '@/components/commons/apeiron-component.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import CatalogosSnp from '@/shared/model/snp/catalogos-snp.factory';
import { PeriodoMenu } from '@/shared/model/snp/plan-estudios-snp.model';
import { PlanDeEstudios, Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { maxValue, minValue, required } from 'vuelidate/lib/validators';

const validations = function () {
  return {
    planDeEstudios: {
      periodoLectivo: {
        required,
      },
      periodicidad: {
        required,
      },
      duracionOficial: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(60),
      },
      totalPeriodosLectivos: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(20),
      },
      porcentajePracticas: {
        minValue: minValue(0),
        maxValue: maxValue(100),
      },
      actividades: {},
      modificacion: {},
      fechaActualizacion: {},
      objetivo: {
        required,
      },
      congruencia: {
        required,
      },
      perfilIngreso: {
        required,
      },
      perfilEgreso: {
        required,
      },
    },
  };
};

@Component({ validations })
export default class PlanEstudiosComponent extends ApeironComponent {
  @Prop({ required: true })
  public readonly solucion!: Solucion;

  @Prop({ required: true })
  public readonly solicitud!: Solicitud;

  @Prop({ required: true })
  public readonly permisos: any;

  @Prop({ required: true })
  public readonly formModel: any;

  public periodosLectivos: Array<PeriodoMenu> = [];
  public periodosNuevoIngreso: Array<PeriodoMenu> = [];

  public planDeEstudios: PlanDeEstudios = new PlanDeEstudios();

  public tabIdx = 0;
  public consultando = false;

  public mounted(): void {
    this.iniciarComponente();
  }

  private iniciarComponente(): void {
    this.periodosLectivos = CatalogosSnp.obtenerOpcionesPlanEstudiosPeriodosLectivos();
    this.periodosNuevoIngreso = CatalogosSnp.obtenerOpcionesPlanEstudiosPeriodosNuevoIngreso();

    this.planDeEstudios = PlanDeEstudios.fromObject(this.solicitud.planDeEstudios ?? new PlanDeEstudios());
  }

  @Emit('guardarSeccion')
  public guardarSeccion(): { planDeEstudios: PlanDeEstudios } {
    return { planDeEstudios: this.planDeEstudios };
  }

  public siguiente(): void {
    this.tabIdx += 1;
  }

  public anterior(): void {
    this.tabIdx -= 1;
  }

  public reiniciaCampoFechaActualizacion(): void {
    this.planDeEstudios.fechaActualizacion = undefined;
  }

  get formularioIsInvalid(): boolean {
    return this.$v.$invalid;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    // El caso finalizada no tiene acciones posibles, se pone por validación de sintaxís de vue
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado ?? EstadoSolicitud.FINALIZADA);
  }
}
